import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_contained/admin/")({
  loader: async () => {
    throw redirect({ to: "/admin/organizations" });
  },
});
